import { TimelineMax } from 'gsap';
import { random } from 'lodash';

const RGBGlitch = (filter) => {
  const tl = new TimelineMax({ paused: true, repeat: -1 });
  tl.addLabel('start');
  for (let i = 0; i < 20; i += 1) {
    tl
      .to(filter.red, 0.01, {
        delay: random(1, 2, false),
        x: random(-10, 10),
        y: random(-10, 10),
      })
      .to(filter.red, 0.01, {
        delay: 0.001,
        x: random(-10, 10),
        y: random(-10, 10),
      })
      .to(filter.red, 0.01, {
        delay: 0.001,
        x: random(-10, 10),
        y: random(-10, 10),
      })
      .to(filter.red, 0.01, {
        delay: 0.001,
        x: random(-10, 10),
        y: random(-10, 10),
      })
      .to(filter.red, 0.01, {
        delay: 0.001,
        x: random(-10, 10),
        y: random(-10, 10),
      })
      .to(filter.red, 0.01, {
        delay: 0.001,
        x: random(-10, 10),
        y: random(-10, 10),
      })
      .to(filter.red, 0.01, {
        delay: 0.1,
        x: 0,
        y: 0,
      });
  }
  return tl;
};

export default RGBGlitch;
